import { render, staticRenderFns } from "./log_page.vue?vue&type=template&id=330fc104&scoped=true"
import script from "./log_page.vue?vue&type=script&lang=js"
export * from "./log_page.vue?vue&type=script&lang=js"
import style0 from "./log_page.vue?vue&type=style&index=0&id=330fc104&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330fc104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330fc104')) {
      api.createRecord('330fc104', component.options)
    } else {
      api.reload('330fc104', component.options)
    }
    module.hot.accept("./log_page.vue?vue&type=template&id=330fc104&scoped=true", function () {
      api.rerender('330fc104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/record/log_page.vue"
export default component.exports